export interface IAnalyticsAccountData {
  accountId: string;
  displayName: string;
}

export const analyticsAccountsPostSuccessResponseValueToAnalyticsAccountData = (
  data: [string, string]
): IAnalyticsAccountData => ({
  accountId: data[0],
  displayName: data[1],
});
